import { css } from 'lit-element';
/* @internal */
export const styles = css`cds-select option{padding:var(--cds-token-space-size-4, 0.3rem);font-size:var(--cds_ng0c91ln3, 0.65rem)}cds-select input::-webkit-calendar-picker-indicator{display:none}
`;
